<template>
  <div id="hzFlow" class="flowClause section">
    <!-- 合作流程 -->
    <div id="flowx" class="flowx animate__animated init--zzQhF">
      <div class="flowx_main_box maxWidth">
        <div class="flow_title">
          <div>合作流程①</div>
          <div></div>
        </div>

        <div class="flow_box">
          <div class="flow_box1">
            <div>
              <div>
                <div class="flow_box1_one">
                  <div>
                    <div>
                      <img src="../../assets/images/pc/flow1.png" alt="千年游戏盒子" />
                    </div>
                    <div class="flow_box_size_margin1">版本选择</div>
                  </div>
                </div>
                <div class="flow_box1_two">
                  我们为开发者提供众多完成度100%的千年底板供您选择
                </div>
              </div>
              <div class="figure">01</div>
            </div>
            <div>
              <div>
                <div class="flow_box1_one">
                  <div>
                    <div>
                      <img src="../../assets/images/pc/flow2.png" alt="千年游戏盒子" />
                    </div>
                    <div class="flow_box_size_margin2">个性化定制</div>
                  </div>
                </div>
                <div class="flow_box1_two">
                  如您对已选版本有个性化需求，我们将评估开发者提出的个性化需求，并给出完成周期
                </div>
              </div>
              <div class="figure">02</div>
            </div>
            <div>
              <div class="paddbox">
                <div class="flow_box1_one">
                  <div>
                    <div>
                      <img src="../../assets/images/pc/flow3.png" alt="" />
                    </div>
                    <div class="flow_box_size_margin3">
                      签署合作协议，支付保证金
                    </div>
                  </div>
                </div>
                <div class="flow_box1_two">
                  签署合作协议并支付保证金后我们将为您搭建专属服务器和配套运营工具，用于版本调整
                </div>
              </div>
              <div class="figure">03</div>
            </div>
            <div>
              <div>
                <div class="flow_box1_one">
                  <div>
                    <div>
                      <img src="../../assets/images/pc/flow4.png" alt="千年游戏盒子" />
                    </div>
                    <div class="flow_box_size_margin4">版本需求</div>
                  </div>
                </div>
                <div class="flow_box1_two">
                  我们将为您的专属游戏服务器完成版本调试，个性化需求开发
                </div>
              </div>
              <div class="figure">04</div>
            </div>
          </div>
          <div class="flow_box1 flow_box2">
            <div class="flow_box2_item">
              <div class="flow_box2_margin">
                <div class="flow_box1_one">
                  <div>
                    <div class="flow5">
                      <img src="../../assets/images/pc/flow5.png" alt="千年游戏盒子" />
                    </div>
                    <div class="flow_box_size_margin1">游戏交付</div>
                  </div>
                </div>
                <div class="flow_box1_two">
                  交付给您已选游戏的最终版本和配套运营+运维工具
                </div>
              </div>
              <div class="figure">05</div>
            </div>
            <div></div>
            <div></div>
            <div class="flow_box2_item">
              <div class="flow_box2_margin">
                <div class="flow_box1_one">
                  <div>
                    <div>
                      <img src="../../assets/images/pc/flow6.png" alt="千年游戏盒子" />
                    </div>
                    <div class="flow_box_size_margin4">正式上线</div>
                  </div>
                </div>
                <div class="flow_box1_two">
                  正式上线后我们将持续辅助您做好正式上线后的游戏运营，推广，后续版本迭代服务
                </div>
              </div>
              <div class="figure">06</div>
            </div>
          </div>
          <div class="flow_box_bg">
            <!-- <img src="./images/PC/flow_box1.gif" alt=""> -->
          </div>
        </div>
        <div class="flow_title addflow_title">
          <div>合作流程②</div>
          <div class="addbottom"></div>
        </div>
        <div class="addflow_box">
          <div class="addflow_box1">
            <div></div>
            <div>若您自有引擎版本或已有正式上线存量版本或存量用户</div>
          </div>
          <div class="addflow_box2">
            我们为您开发了千年引擎转换工具，便捷实现数据，资源转化，快速移植原版资源，具体合作细则您可咨询商务人员
          </div>
        </div>
      </div>
    </div>
   
  </div>
</template>

<script>
export default {
  data() {
    return {
    
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.flowx {
	width: 100%;
	height: 13.1125rem
		/* 1049/80 */
	;
	background: #f3f3f1;
}
.flowx_main_box{
	background: url("../../assets/images/pc/flow_bg.jpg") no-repeat;
	background-size: cover;
	height: 100%;
}
.flow_title {
	text-align: center;
}

.addflow_title {
	position: relative;
	top: 1.5rem
		/* 120/80 */
	;
}

.addflow_box {
	top: 2rem
		/* 160/80 */
	;
	position: relative;
	margin: 0 auto;
	width: 15.275rem
		/* 1222/80 */
	;
	height: 1.45rem
		/* 116/80 */
	;
	padding: .25rem
		/* 20/80 */
		.5rem
		/* 40/80 */
	;
	border-radius: 0.125rem
		/* 10/80 */
	;
	background: #fff;
	box-sizing: border-box;
}

.addflow_box1 {
	display: flex;

	color: #000000;
	font-size: .275rem
		/* 22/80 */
	;
	font-weight: bold;
}

.addbottom {
	background: linear-gradient(to right, #edeee9, #e5e5e3 50%, #edeee9);
}

.addflow_box1>div:nth-child(1) {
	margin: 0 .125rem
		/* 10/80 */
	;
	width: .3rem
		/* 24/80 */
	;
	height: .3375rem
		/* 27/80 */
	;
	background: url("../../assets/images/pc/bb.png") no-repeat center;
	background-size: cover;
}

.addflow_box2 {
	margin-top: .2rem
		/* 16/80 */
	;
	font-size: .175rem
		/* 14/80 */
	;
	color: #666666;
}

.flow_title>div:nth-child(1) {
	font-size: .45rem
		/* 36/80 */
	;
	color: #000000;
	padding-top: .775rem
		/* 62/80 */
	;
	margin-bottom: .3125rem
		/* 25/80 */
	;
	font-weight: bold;
}

.flow_title>div:nth-child(2) {
	width: 10.875rem
		/* 870/80 */
	;
	height: 1px;
	margin: 0 auto;
	background: linear-gradient(to right, #edeee9, #dfe0db 50%, #edeee9);
}

.flow_box {
	width: 15.275rem
		/* 1222/80 */
	;
	height: 4.5875rem
		/* 367/80 */
	;
	margin: 0 auto;
	margin-top: 1.05rem
		/* 84/80 */
	;
	border-radius: .125rem
		/* 10/80 */
	;
	background: #fff;
	position: relative;
}

.flow_box .flow_box_bg {
	position: absolute;
	left: 0;
	right: 0;
	bottom: -52%;
	margin: 0 auto;
	width: 5rem
		/* 400/80 */
	;
	height: 5rem
		/* 400/80 */
	;
	background-size: cover;
	background: url("../../assets/images/pc/flow_box1.gif") no-repeat center;
	background-size: cover;
}

.flow_box .flow_box_bg img {
	display: block;
	width: 100%;
	height: 100%;
}

.flow_box>div {
	width: 100%;
	min-height: 2.2875rem
		/* 183/80 */
	;
	box-sizing: border-box;
	display: flex;
}

.flow_box1 {
	border-bottom: 1px solid #f2f2f2;
}

.flow_box2 {
	border: none;
}

.flow_box2 .flow_box2_item {
	align-items: inherit !important;
}

.flow_box2 .flow_box2_margin {
	margin-top: .25rem
		/* 20/80 */
	;
}

.flow_box1>div {
	flex: 1;
	display: flex;
	align-items: center;
}

.flow_box1>div:nth-child(3) {
	flex: 1.2;
}

.flow_box1>div {
	position: relative;
}

.figure {
	position: absolute;
	right: 0;
	bottom: 0;
	font-size: .55rem
		/* 44/80 */
	;
	color: #e9d7d6;

}

.flow_box1>div>div {
	padding: 0 .5rem
		/* 40/80 */
	;
}

.flow_box1>div .paddbox {
	padding: 0 .25rem
		/* 20/80 */
	;
}

.flow_box1_one {
	color: #000000;
	font-size: .275rem
		/* 22/80 */
	;
	font-weight: bold;
	display: flex;
	justify-content: center;

}

.flow5 {
	margin-left: .375rem
		/* 30/80 */
	;
}

.flow_box1_one>div {
	display: flex;
}

.flow_box1_one>div>div:nth-child(1) {
	width: .425rem
		/* 34/80 */
	;
	height: .425rem
		/* 34/80 */
	;
	display: flex;
	flex-direction: column-reverse;
}

.flow_box1_one>div>div:nth-child(2) {
	display: flex;
	flex-direction: column-reverse;
}


.flow_box_size_margin1 {
	margin-left: .1625rem
		/* 13/80 */
	;
}

.flow_box_size_margin2 {
	margin-left: .25rem
		/* 20/80 */
	;
}

.flow_box_size_margin3 {
	margin-left: .0625rem
		/* 5/80 */
	;
}

.flow_box_size_margin4 {
	margin-left: .2rem
		/* 16/80 */
	;
}

.flow_box1_two {
	padding-top: .125rem
		/* 10/80 */
	;
	font-size: .175rem
		/* 14/80 */
	;
	color: #666666;
	line-height: .3rem
		/* 24/80 */
	;
	padding-bottom: .25rem
		/* 20/80 */
	;
	height: .75rem
		/* 60/80 */
	;
}
</style>
